import React from 'react';
import { Modal } from 'antd';
import pluralize from 'pluralize';

// eslint-disable-next-line import/no-anonymous-default-export
export default (passengers, callback) => {
    const paxWithNullPerson = passengers.filter(pax => !pax.personID);
    const validPax = passengers.filter(pax => pax.personID);

    const invalidPax = validPax.filter(pax => {
        if (pax.bagWeight && !pax.bagCount){
            return true;
        }
        if (!pax.paxWeight || !pax.bagWeight){
            return true;
        }
        return false;
    });
    const paxWithNoPaxWeight = invalidPax.filter(pax => !pax.paxWeight);
    const paxWithNoBagWeight = invalidPax.filter(pax => !pax.bagWeight);
    const paxWithinvalidBagCount = invalidPax.filter(pax => pax.bagWeight && !pax.bagCount);
    const hasOrHave = (count) => count !== 1 ? 'have' : 'has';

    const hasIssues = invalidPax.length > 0 || paxWithNullPerson.length > 0;

    if (hasIssues){
        Modal.confirm({
            title: 'Problems detected',
            content: (
                <div>
                    <ul>
                        {paxWithNullPerson.length ? (
                            <li>
                                <strong>
                                    {paxWithNullPerson.length} {pluralize('passenger', paxWithNullPerson.length)} {hasOrHave(paxWithNullPerson.length)} a deleted person record
                                    and {paxWithNullPerson.length === 1 ? 'will be' : 'will be'} removed upon save:
                                </strong>
                                <ul>
                                    {paxWithNullPerson.map((pax, i) => (
                                        <li key={pax._id || i}>{pax.lastName}, {pax.firstName}</li>
                                    ))}
                                </ul>
                            </li>
                        ) : null}
                        {paxWithNoPaxWeight.length ? <li>{paxWithNoPaxWeight.length} {pluralize('passenger', paxWithNoPaxWeight.length)} {hasOrHave(paxWithNoPaxWeight.length)} zero set as their weight.</li> : null}
                        {paxWithNoBagWeight.length ? <li>{paxWithNoBagWeight.length} {pluralize('passenger', paxWithNoBagWeight.length)} {hasOrHave(paxWithNoBagWeight.length)} zero set as their bag weight.</li> : null}
                        {paxWithinvalidBagCount.length ? <li>{paxWithinvalidBagCount.length} {pluralize('passenger', paxWithinvalidBagCount.length)} {hasOrHave(paxWithinvalidBagCount.length)} bag weight but {hasOrHave(paxWithinvalidBagCount.length)} no bags.</li> : null}
                    </ul>
                    <p>If this is intended, please click continue. Otherwise, please click cancel and correct these errors.</p>
                </div>
            ),
            onOk: () => callback(),
            okText: 'Continue',
            icon: 'exclamation-circle',
            autoFocusButton: 'cancel',
            okButtonProps: {
                type: 'default'
            },
            cancelButtonProps: {
                type: 'primary'
            }
        })
    }
    else
    {
        callback()
    }
}